/* Preserve Shopify's policy copy and links while adding a readable outline. */
(() => {
  const enhancePolicy = () => {
    const container = document.querySelector('.nova-policy-route .shopify-policy__container');
    const body = container?.querySelector('.shopify-policy__body');
    const title = container?.querySelector('.shopify-policy__title');
    if (!body || !title || container.dataset.novaPolicyEnhanced) return;
    container.dataset.novaPolicyEnhanced = 'true';
    // Legacy page content repeats its title; preserve the stored legal copy.
    const normalizeTitle = (text) => text.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]/g, '');
    const pageTitle = normalizeTitle(title.querySelector('h1').textContent);
    body.querySelectorAll('h1, h2').forEach((heading) => {
      if (normalizeTitle(heading.textContent) === pageTitle) {
        const duplicate = document.createElement('div');
        duplicate.hidden = true;
        duplicate.innerHTML = heading.innerHTML;
        heading.replaceWith(duplicate);
      }
      else if (heading.tagName === 'H1') {
        const subheading = document.createElement('h2');
        subheading.innerHTML = heading.innerHTML;
        if (heading.id) subheading.id = heading.id;
        heading.replaceWith(subheading);
      }
    });
    const eyebrow = document.createElement('p');
    eyebrow.className = 'nip-eyebrow';
    eyebrow.textContent = 'THE DETAILS';
    title.querySelector('h1').before(eyebrow);
    const crumbTemplate = document.getElementById('NovaBreadcrumbTemplate');
    if (!title.querySelector('.nova-store-crumb') && crumbTemplate) eyebrow.before(crumbTemplate.content.cloneNode(true));
    const subheadings = new Set(['Interpretation', 'Definitions', 'Types of Data Collected', 'Personal Data', 'Usage Data', 'Tracking Technologies and Cookies', 'Use of Your Personal Data', 'Retention of Your Personal Data', 'Transfer of Your Personal Data', 'Delete Your Personal Data', 'Disclosure of Your Personal Data', 'Business Transactions', 'Law enforcement', 'Other legal requirements', 'Security of your Personal Data', 'Severability', 'Waiver']);
    body.querySelectorAll('.rte > p').forEach((paragraph) => {
      const text = paragraph.textContent.trim();
      const boldText = [...paragraph.querySelectorAll('b, strong')].map((node) => node.textContent.trim()).join('');
      if (!text || text !== boldText) return;
      const heading = document.createElement(subheadings.has(text) ? 'h3' : 'h2');
      heading.textContent = text;
      paragraph.replaceWith(heading);
    });
    const headings = [...body.querySelectorAll('h2')];
    if (!headings.length) return;
    const sidebar = document.createElement('aside');
    sidebar.className = 'nova-policy-sidebar';
    const nav = document.createElement('nav');
    nav.className = 'nova-policy-nav';
    nav.setAttribute('aria-label', 'On this page');
    const outline = document.createElement('details');
    const mobile = window.matchMedia('(max-width: 749px)');
    outline.open = !mobile.matches;
    mobile.addEventListener('change', (event) => { outline.open = !event.matches; });
    const label = document.createElement('summary');
    label.textContent = 'On this page';
    const list = document.createElement('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `NovaPolicySection-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link);
      list.append(item);
    });
    outline.append(label, list);
    nav.append(outline);
    sidebar.append(nav);
    const related = document.createElement('nav');
    related.className = 'nova-policy-links';
    related.setAttribute('aria-label', 'Helpful links');
    const relatedLabel = document.createElement('h2');
    relatedLabel.textContent = 'Helpful links';
    related.append(relatedLabel);
    const root = (title.querySelector('.nova-store-crumb a')?.getAttribute('href') || '/').replace(/\/?$/, '/');
    [['policies/privacy-policy', 'Privacy policy'], ['policies/terms-of-service', 'Terms of service'], ['pages/contact', 'Contact us']].forEach(([path, text]) => {
      const link = document.createElement('a');
      link.href = `${root}${path}`;
      link.textContent = text;
      if (new URL(link.href).pathname === location.pathname) link.setAttribute('aria-current', 'page');
      related.append(link);
    });
    sidebar.append(related);
    const layout = document.createElement('div');
    layout.className = 'nova-policy-layout';
    body.before(layout);
    layout.append(sidebar, body);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhancePolicy, { once: true });
  else enhancePolicy();
})();
